<template>
  <span>
    <contact-address></contact-address>
  </span>
</template>
<script>
import ContactAddress from '@/components/contact/Address'
export default {
  name: 'Contact',
  components: {
    ContactAddress
  }
}
</script>
<style scoped></style>
